export default {
  development: {
    public_key: "pk_test_51HcrOxHLd0x1guwyUmPONVDz4yocL7IVuHAMECIyOPPcfAELCiyRXN09Rjrx3MJekxoSzsEcqn3ZzVp2nksrpZyi00NYtQjHTS",
  },
  production: {
    public_key: "AZa2VAf_v6vrnTGs6RQGxlB9XWk_r8Z27XCW-kHj58BZNotxypNeMdTEKHRdWtel693CdBAhkHYfiV2r",
  },
  currency: "USD"
}